// Every article gets an auto-generated 1200x630 share card at public/og/<slug>.png:
// the article's cover photo as the background with the 20 PROOF logo overlaid.
// Regenerate with /tmp/gen_cards.py whenever an article's cover image changes.
export const shareImageFor = (article) => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}/og/${article.slug}.png?v=2`;
};
